import MuiModal from '@material-ui/core/Modal';
import React, { useCallback, useEffect } from 'react';
import classNames from 'classnames';
import { Button, IconClose } from '..';
import { injectIntl } from '../../utils/reactIntl';
import './Modal.global.scss';



interface Props {
  children?: React.ReactNode,
  className?: string,
  scrollLayerClassName?: string,
  containerClassName?: string,
  contentClassName?: string,
  lightCloseButton?: boolean,
  id: string,
  intl: any,
  isClosedClassName?: string,
  isOpen?: boolean,
  onClose?: any,
  onManageDisableScrolling: any
  showOnClose?: boolean;
}

const ModalComponent: React.FC<Props> = (props: Props) => {
  const {
    id,
    intl,
    onManageDisableScrolling,
    children = null,
    className = '',
    scrollLayerClassName = '',
    containerClassName = '',
    contentClassName = '',
    lightCloseButton = false,
    isClosedClassName = "isClosed",
    isOpen = false,
    onClose = null,
    showOnClose = true,

  } = props;

  const handleClose = useCallback((event: any) => {
    onManageDisableScrolling(id, false);
    onClose(event);
  }, [id, onClose, onManageDisableScrolling]);

  useEffect(() => {
    onManageDisableScrolling(id, isOpen);
    return () => {
      onManageDisableScrolling(id, false);
    };
  }, [onManageDisableScrolling, id, isOpen]);

  const closeModalMessage = intl.formatMessage({ id: 'Modal.closeModal' });
  const closeButtonClasses = classNames('close', {
    ['closeLight']: lightCloseButton,
  });
  const closeBtn = isOpen ? (
    <Button
      onClick={handleClose}
      rootClassName={closeButtonClasses}
      title={closeModalMessage}
    >
      <IconClose rootClassName="closeIcon" />
    </Button>
  ) : null;

  const modalClass = isOpen ? 'isOpen' : isClosedClassName;
  const classes = classNames(modalClass, className);
  const scrollLayerClasses = scrollLayerClassName || 'scrollLayer';
  const containerClasses = containerClassName || 'container_modal';

  return (
    <MuiModal open={isOpen} onClose={handleClose} className={classes} hideBackdrop>
      <div className={scrollLayerClasses}>
        <div className={containerClasses} role="dialog" aria-modal="true" aria-label={id} tabIndex={-1}>
          {showOnClose && closeBtn}
          <div className={classNames(contentClassName || 'content')}>{children}</div>
        </div>
      </div>
    </MuiModal>
  );
};

export default injectIntl(ModalComponent);
